var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCareboard = function SvgCareboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    clipPath: "url(#careboard_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 8.333h-3.333a3.333 3.333 0 0 0-3.334 3.334v20A3.334 3.334 0 0 0 11.667 35h16.666a3.333 3.333 0 0 0 3.334-3.333v-20a3.333 3.333 0 0 0-3.334-3.334H25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 8.333A3.333 3.333 0 0 1 18.333 5h3.334a3.333 3.333 0 0 1 0 6.667h-3.334A3.333 3.333 0 0 1 15 8.333M19.986 27.917l4.578-4.692a3.167 3.167 0 0 0 0-4.387 2.96 2.96 0 0 0-4.266 0l-.305.314-.305-.315a2.96 2.96 0 0 0-4.267 0 3.165 3.165 0 0 0 0 4.387l4.563 4.708z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "careboard_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgCareboard;